import { Box } from "@mui/material";
import Warning from "./Warning";

export default function MainWrapper({ children, drawerWidth }) {
    return (
        <Box
            component="main"
            sx={{
                position: "relative",
                flexGrow: 1,
                padding: 0,
                width: { sm: `calc(100% - ${drawerWidth}px)` },
            }}
        >
            <Box sx={{ marginTop: { sm: "64px" } }}>{children}</Box>
        </Box>
    );
}
